
// Use this error object if you don't care about the API exposing this
// error to the end user's machine
function SafeError(message) {
  this.name = 'SafeError';
  this.message = message;
  this.stack = (new Error()).stack;
}
SafeError.prototype = new Error();

export default SafeError;
